<div class="OverLay" *ngIf="showLoaderPopUp && popUpParameter=='WidgetLayout' "></div>
<div class="popup-container" *ngIf="showLoaderPopUp && popUpParameter=='WidgetLayout' ">
  <div class="popup-header">
    <div class="header-text">SNAPSHOT LAYOUT</div>
    <div class="close-icon" (click)="closeClick()"></div>
  </div>
  <div class="popup-inner-container">
    <div class="popup-content-parent">
      <div class="image-radio-group">
        <div *ngFor="let image of images">
          <div class="image-radio-button" (click)="isSelectedWidget(image)">
            <div class="radio-container">
              <div class="radio-icon" [ngClass]="{'radio-icon-active': image.selected}"></div>
              <label>{{image.name}}</label>
            </div>
            <div class="image-container">
              <img [src]="!image.selected?image.url:image.activeurl" alt="Image">
            </div>

          </div>
        </div>
      </div>
      <!-- <div *ngFor="let client of filteredData">
          <div class="clientList">
            <div class="clientName" [ngClass]="{ selected: client.showStudies }" (click)="toggleStudies(client)">
              {{ client.ClientName }}
            </div>
            <div class="arrowToggle" [ngClass]="{
                  selected: client.showStudies,
                  'arrow-collapsed': client.showStudies
                }" (click)="toggleStudies(client)"></div>
          </div>

          <div *ngIf="client.showStudies">
            <div class="studyDetails">
              <div *ngFor="let study of client.UniqueStudies">
                <div class="studyList" (click)="
                      selectStudy(client.ClientName, study, client.ClientCode)
                    ">
                  <div class="radio-icon" [ngClass]="{
                        'radio-icon-active': isSelected(
                          client.ClientName,
                          study
                        )
                      }"></div>
                  <div class="radio-text">{{ study }}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

    </div>


    <div class="popup-footer">
      <div class="config-btn config-footer-btn" (click)="SubmitWidget()">
        <div class="btn-icon Icon_Navigate"></div>
        <div class="btn-text">Submit</div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<!-- <div class="OverLay" *ngIf="showErrorPopUp && popUpParameter=='WidgetLayout' "></div> -->
<div class="e-OverLay" *ngIf="showErrorPopUp"></div>
<div class="e-popup-container" *ngIf="showErrorPopUp">
  <div class="e-popup-model">
    <div class="e-popup-header">
      <div class="e-popup-header-text">{{errorheaderTitle}}</div>
      <div class="e-popup-close" (click)="closeErrorPopUpClick()" title="Close"></div>
    </div>
    <div class="e-popup-body">
      <div class="e-message-block" [ngStyle]="{
              display:customcss(popUpMessage),'height':heightValue
            }">
  <span [innerHTML]="popUpMessage"></span>
      </div>
    </div>
    <div class="e-popup-footer" *ngIf="buttonText!=''">
      <div class="e-popup-btn" (click)="onerrorPopUpOkBtnClick()">
        <div class="e-btn-icon e-check-circle-icon"></div>
        <div class="e-btn-text">{{buttonText}}</div>
      </div>
    </div>
  </div>
</div>

<div class="e-popup-container" *ngIf="showConfirmationPopUp && popUpParameter=='Confirmation'">
  <div class="e-popup-model">
    <div class="e-popup-header">
      <div class="e-popup-header-text">{{errorheaderTitle}}</div>
      <div class="e-popup-close" (click)="onConfirmationPopUpCancelBtnClick()" title="Close"></div>
    </div>
    <div class="e-popup-body">
      <div class="e-message-block" [ngStyle]="{
              display:customcss(popUpMessage),'height':heightValue
            }">
        {{popUpMessage}}
      </div>
    </div>
    <div class="e-popup-footer">
      <div class="e-popup-btn" (click)="onConfirmationPopUpCancelBtnClick()">
        <div class="e-btn-icon e-check-circle-cancel-icon"></div>
        <div class="e-btn-text">Cancel</div>
      </div>
      <div class="e-popup-btn" (click)="onConfirmationPopUpOkBtnClick()">
        <div class="e-btn-icon e-check-circle-icon"></div>
        <div class="e-btn-text">Proceed</div>
      </div>
    </div>
  </div>
</div>

<div class="popup-container-new input-global" *ngIf="showInputPopUp">
  <div class="popup-model-load-global popup-model" id="inputGlobalPopup">
    <div class="popup-header-info">
      <div class="popup-header-text">{{infoheaderTitle}}</div>
      <div class="popup-close-new" (click)="closeInputPopUpClick()" title="Close"></div>
    </div>
    <div class="popup-body" style="max-height: calc(100% - 4rem);">
      <div class="textWrap" style="font-size:0.75rem; line-height:1.1rem; text-align:left;height:8.5rem" [innerHTML]="popUpMessage">
      </div>
    </div>
    <div class="popup-footer-save" style="justify-content:flex-end;">
    </div>
  </div>
</div>

<!-- Sample Size -->
<div class="OverLay" *ngIf="showSampleSizePopup && popUpParameter=='SampleSize' && !trendSamplesizeview"></div>
<div [ngClass]="{'i-popup-container':!trendSamplesizeview,'i-popup-container-trend-samplesize':trendSamplesizeview}" *ngIf="showSampleSizePopup" (clickOutside)="onOutsideClick($event)">
  <div [ngClass]="{'i-popup-model-samplesize':!trendSamplesizeview,'i-popup-model-trend-samplesize':trendSamplesizeview}">
    <div class="i-popup-header-samplesize"  *ngIf="!trendSamplesizeview">
      <div class="i-popup-header-text">{{"Sample Size"}}</div>
      <!-- <ng-container *ngIf="this.snapShotTypeSelected != 'multiple'">
        <div id="FF">
          <div
            [style]="unWeightedBaseInput?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
            id="FFyesno" class="toggleButtons" (click)="toggleUnWeights()">Unweighted Base</div>
            <div
            [style]="weightedBaseInput?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
            id="FFyesno" class="toggleButtons" (click)="toggleWeights()">Weighted Base</div>
        </div>
      </ng-container> -->
      <!-- <ng-container *ngIf="this.snapShotTypeSelected == 'multiple'"> -->




      <div class="i-popup-close-samplesize" (click)="closeSamplesizePopUpClick()" title="Close"></div>
    </div>
    <div  [ngClass]="{'i-popup-body-samplesize':!trendSamplesizeview,'i-popup-body-trend-samplesize':trendSamplesizeview}">
      <!-- <div class="i-message-block" [ngStyle]="{
              display:customcss(popUpMessage),'height':heightValue
            }">
        {{popUpMessage}}
      </div> -->
      <div class="dropdowns-samplesize">
        <div class="view-dropdown-container" *ngIf="this.snapShotTypeSelected == 'multiple' || (this.snapShotTypeSelected == 'audience' && this._configService.multiCohort )&& !trendSamplesizeview">
          <div class="dropdown-container-first" [style]="'width:43% !important'">
            <div class="dropdown-container-text">View</div>
            <div class="dd" (click)="$event.stopPropagation(); OnViewDropDown()" DocumentClick (DocumentClicked)="this.showViewDropDown=false">
              <p class="dropdown-text">{{dropDownLevel1SelectedKey}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': this.showViewDropDown}" style="top:23%"></div>
              <div *ngIf="showViewDropDown" class="view-dropdown">
                <div *ngFor="let item of dropdownText" class="dropdown-options">
                  <div style="display:flex;position:relative;width: 100%;"
                    (click)="OnViewSelected(item.key, item.dropdownId)">
                    <div class="itemData text-ellipsis" style="height:1.3rem;width: 100%;" title="{{item.key}}"
                      [ngClass]="{'bg-active': dropDownLevel1SelectedId === item.dropdownId}">
                      <span style="padding-left:2%">{{item.key}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div *ngIf="showViewDropDown" class="view-dropdown">
              <div *ngFor="let item of dropdownText" class="dropdown-options">
                <div style="display:flex;position:relative;width: 100%;"(click)="OnViewSelected(item.key, item.dropdownId)"  >
                  <div class="itemData text-ellipsis" style="height:1.3rem;width: 100%;" title="{{item.key}}" [ngClass]="{'bg-active': dropDownLevel1SelectedId === item.dropdownId}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="dropdown-container-first" [style]="'width:50% !important'" [ngClass]="{ disabled: this.dropDownLevel1SelectedId == 0}">
            <div class="dropdown-container-text">Selection</div>
            <div class="dd" (click)="$event.stopPropagation(); ClickOnLevel2ViewDropDown()">
              <p class="dropdown-text">{{dropDownLevel2SelectedValue}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': this.showLevel2DropDown}" style="top:23%">
              </div>
              <div class="view-dropdown" *ngIf="showLevel2DropDown">
                <div class="dropdown-options" *ngFor="let item of dropDownLevel2" (click)="OnRadioModuleToggle(item)"
                  [ngClass]="{ 'bg-active': item.is_selected }">
                  <div class="radio-icon radio-inactive" [ngClass]="{ 'radio-active': item.is_selected }"></div>
                  <div class="option-text text-ellipsis" title="{{ item.name }}">
                    {{ item.displayName }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="dropdown-inner-container" *ngIf="showLevel2DropDown">
              <div class="dropdown-options" *ngFor="let item of dropDownLevel2" (click)="OnRadioModuleToggle(item)" [ngClass]="{ 'bg-active': item.is_selected }">
                <div class="radio-icon radio-inactive" [ngClass]="{ 'radio-active': item.is_selected }"></div>
                <div class="option-text text-ellipsis" title="{{ item.name }}">
                  {{ item.name }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!-- <div class="TrendToggle-Container-Main" [ngClass]="{'disabled':!_configService.isTrendEnabled}">
          <div class="dropdown-container-text">Trend</div>
          <div id="TrendToggle-Container">

            <div [ngClass]="TrendToggleOn?'active-toggle':'deactive-toggle'" id="TrendToggle-Container-Buttons"
              class="toggleButtons" (click)="TrendOnClick()">On</div>
            <div [ngClass]="!TrendToggleOn?'active-toggle':'deactive-toggle'" id="TrendToggle-Container-Buttons"
              class="toggleButtons" (click)="TrendOffClick()">Off</div>
          </div>
        </div> -->


         <div *ngIf="TrendToggleOn" class="TrendToggle-Container-Main" style="margin-right: 10px;">          
          <div id="TrendToggle-Container">
            <div [ngClass]="isTrendView?'active-toggle':'deactive-toggle'" 
              class="toggleButtons" style="width: 5.5rem" id="TrendToggle-Container-Buttons" (click)="toggleTrendSample('trendview')">Trend View</div>
            <div [ngClass]="isSampleSize?'active-toggle':'deactive-toggle'" 
              class="toggleButtons" style="width: 5.5rem" id="TrendToggle-Container-Buttons" (click)="toggleTrendSample('samplesize')">Sample Size</div>
          </div>
        </div>

        <!-- <div class="trend-or-samplesize">
          <div class="toggle-container" (click)="toggleTrendSample('trendview')"
              [ngClass]="{'Selected':isTrendView}">Trend View</div>
          <div class="toggle-container" (click)="toggleTrendSample('samplesize')"
              [ngClass]="{'Selected':isSampleSize}">Sample Size</div>
      </div> -->
        <ng-container>
          <div class="dropdown-container-first" [style]="'width:13% !important'">
            <div class="dd" (click)="$event.stopPropagation(); OnBaseDropDown()">
              <p class="dropdown-text">{{dropDownBaseSelectedName}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': this.showBaseViewDropDown}" style="top:23%">
              </div>
              <div *ngIf="showBaseViewDropDown" class="base-view-dropdown">
                <div *ngFor="let item of BaseDropDown" class="dropdown-options">
                  <div style="display:flex;position:relative;width: 100%;" (click)="OnBaseSelected(item)">
                    <div class="itemData text-ellipsis" style="height:1.3rem;width: 100%;" title="{{item.key}}"
                      [ngClass]="{'bg-active': item.is_selected}">
                      <span style="padding-left:2%">{{item.base}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div *ngIf="showBaseViewDropDown" class="base-view-dropdown">
              <div *ngFor="let item of BaseDropDown" class="dropdown-options">
                <div style="display:flex;position:relative;width: 100%;"(click)="OnBaseSelected(item)"  >
                  <div class="itemData text-ellipsis" style="height:1.3rem;width: 100%;" title="{{item.key}}" [ngClass]="{'bg-active': item.is_selected}">
                    <span style="padding-left:2%">{{item.base}}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </ng-container>
      </div>
      <div class="samplesize-table">
        <app-table-output-snapshot [snapshotdata]="snapshotdata" [MainData]="OutputdataObject"
          [isTranspose]="isTranspose" [isTotalBase]="isTotalBase" [isAnswerBase]="isAnswerBase"
          [isSampleSize]="isSampleSize" [TrendToggleOn]="TrendToggleOn" [TrendToggleContainer]="TrendToggleContainer"
          [weightedBaseInput]="weightedBaseInput" [dropDownData]="dropDownData"
          [defaultShowSampleSize]="defaultShowSampleSize" [selectedweight]="selectedweight"
          [snapshotType]="this.snapShotTypeSelected"[isAudienceType]="isAudienceType"
          [dropDownBaseSelectedName]="dropDownBaseSelectedName"></app-table-output-snapshot>
      </div>
    </div>
  </div>
</div>

<div class="popup-container-load" style="font-size: 0.7rem;" *ngIf="showLoadSelection" id="loadSelectionPopup">
  <div class="popup-model-load popup-model">
    <div class="popup-header-load">
      <div class="popup-header-text-load">Load Selection</div>
      <div class="popup-close-load" (click)="closeLoadPopUp()" title="Close"></div>
    </div>
    <div class="popup-body">
      <div class="infoMessage" *ngIf="!displayTable">
        <div class="backbutton config-btn CP" (click)="bindBackClickEvent()">
          Back
        </div>
        <div class="infoText" [innerHTML]="infoMessage"></div>
      </div>
      <div *ngIf="displayTable" class="loadSelectionTable">
        <div class="header-block list-container-options">
          <div class="header-arrow-block">
            <div class="list-container-text" (click)="toggleSaveSelectionList('userDefined')"> User Defined</div>
            <div class="search-block" title="Search"
              *ngIf="isUserDefinedListVisible && loadUserDefinedSavedScenarioData.length>0">
              <input type="text" [(ngModel)]="userDefinedSelectionQuery" class="search-input" placeholder="Search">
              <div class="search-icon"></div>
            </div>
            <div class="arrow" (click)="toggleSaveSelectionList('userDefined')">
              <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isUserDefinedListVisible}">
              </div>
            </div>
          </div>

        </div>
        <div class="list-container-options" *ngIf="isUserDefinedListVisible">
          <div class="custom-table-container">

            <!-- <table class="custom-table" *ngIf="displayTable"> -->
            <table class="custom-table">
              <thead *ngIf="loadUserDefinedSavedScenarioData.length>0">
                <tr>
                  <ng-container *ngFor="let col of columnConfig">
                    <ng-container *ngIf="isChangeOfEntryPointConfigured">
                      <th [style.width]="col.userDefined_width">
                        {{ col.name }}
                      </th>
                    </ng-container>
                    <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                      <th [style.width]="col.userDefined_width_change">
                        {{ col.name }}
                      </th>
                    </ng-container>
                  </ng-container>

                </tr>
              </thead>
              <tbody class="custom-load-table-body">
                <tr
                  *ngFor="let row of loadUserDefinedSavedScenarioData| search: userDefinedSelectionQuery : ['selection_name']">
                  <td [style.width]="isChangeOfEntryPointConfigured? '60%':'80%'"
                    [title]="row.is_shared ? row.selection_name + '_Shared' : row.selection_name"
                    [ngClass]="{'ellipsis-cell': isChangeOfEntryPointConfigured,'ellipsis-cell-noentry': !isChangeOfEntryPointConfigured }">
                    <div class="scenarioName">
                      <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                        value="{{row.selection_name}}" [checked]="row.is_default"
                        (click)="selectDefaultLoadOption($event,row.selection_name,row,'userDefined')">
                      {{ row.is_shared ? row.selection_name + '_Shared' : row.selection_name }}
                    </div>
                  </td>

                  <ng-container *ngIf="isChangeOfEntryPointConfigured">

                    <td [style.width]="'10%'" class="imageContainer CP LoadImage"
                      (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                    <td [style.width]="'10%'" class="imageContainer CP InfoImage"
                      (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                    <td [style.width]="'10%'" class="imageContainer CP DeleteImage"
                      (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>

                    <!-- <td [style.width]="'14%'" class="imageContainer CP changeEntryPointImage"
                      (click)="handleLoadOptionsClick('changeentrypoint', row,'userDefined')"></td> -->

                    <td [style.width]="'10%'" class="imageContainer CP ShareImage"
                      (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>

                  </ng-container>

                  <ng-container *ngIf="!isChangeOfEntryPointConfigured ">
                    <td [style.width]="'5%'" class="imageContainer CP LoadImage"
                      (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                    <td [style.width]="'5%'" class="imageContainer CP InfoImage"
                      (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                    <td [style.width]="'5%'" class="imageContainer CP DeleteImage"
                      (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>
                    <td [style.width]="'5%'" class="imageContainer CP ShareImage"
                      (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>
                  </ng-container>



                </tr>
                <tr class="no-data" *ngIf="loadUserDefinedSavedScenarioData.length==0">
                  You have not created any saved selections.
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="header-block list-container-options">
          <div class="header-arrow-block">
            <div class="list-container-text" (click)="toggleSaveSelectionList('Shared With Me')"> Shared With Me</div>
            <div class="search-block" title="Search"
              *ngIf="isSharedWithMeListVisible && loadSharedWithMeSavedScenarioData.length>0">
              <input type="text" [(ngModel)]="sharedWithMeSelectionQuery" class="search-input" placeholder="Search">
              <div class="search-icon"></div>
            </div>
            <div class="arrow" (click)="toggleSaveSelectionList('Shared With Me')">
              <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isSharedWithMeListVisible}">
              </div>
            </div>
          </div>

        </div>
        <div class="list-container-options" *ngIf="isSharedWithMeListVisible">
          <div class="custom-table-container">

            <!-- <table class="custom-table" *ngIf="displayTable"> -->
            <table class="custom-table">
              <thead *ngIf="loadSharedWithMeSavedScenarioData.length>0">
                <tr>
                  <!--<th *ngFor="let col of columnConfig.slice(0, -1)" [style.width]="col.sharedWithMe_width">
                    {{ col.name }}
                  </th>-->

                  <ng-container *ngFor="let col of columnConfig.slice(0, -1)">
                    <ng-container *ngIf="isChangeOfEntryPointConfigured">
                      <th [style.width]="col.sharedWithMe_width">
                        {{ col.name }}
                      </th>
                    </ng-container>
                    <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                      <th [style.width]="col.sharedWithMe_width_change">
                        {{ col.name }}
                      </th>
                    </ng-container>
                  </ng-container>
                  <th style="width: 30%;">
                    Email
                  </th>




                </tr>
              </thead>
              <tbody class="custom-load-table-body">
                <tr
                  *ngFor="let row of loadSharedWithMeSavedScenarioData | search: sharedWithMeSelectionQuery : ['selection_name','user_name']">
                  <td [style.width]="isChangeOfEntryPointConfigured? '40%' : '55%'" [attr.title]="row.selection_name"
                    [ngClass]="{'ellipsis-cell-shared': isChangeOfEntryPointConfigured,'ellipsis-cell-shared-noentry': !isChangeOfEntryPointConfigured }">
                    <div class="scenarioName">
                      <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                        value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                        (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')">
                      {{ row.selection_name }}
                    </div>
                  </td>
                  <ng-container *ngIf="isChangeOfEntryPointConfigured">
                    <td [style.width]="'10%'" class="imageContainer CP LoadImage"
                      (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                    <td [style.width]="'10%'" class="imageContainer CP InfoImage"
                      (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                    <td [style.width]="'10%'" class="imageContainer CP DeleteImage"
                      (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>

                  </ng-container>

                  <ng-container *ngIf="!isChangeOfEntryPointConfigured">
                    <td [style.width]="'5%'" class="imageContainer CP LoadImage"
                      (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                    <td [style.width]="'5%'" class="imageContainer CP InfoImage"
                      (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                    <td [style.width]="'5%'" class="imageContainer CP DeleteImage"
                      (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>



                  </ng-container>
                  <td style="width: 30%;" title="{{row.user_name}}">
                    <div class="scenarioName">{{ row.user_name }}</div>
                  </td>

                </tr>
                <tr class="no-data" *ngIf="loadSharedWithMeSavedScenarioData.length==0">
                  No saved selections have been shared with you.
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="loadSelectionNoteDiv"><span class="loadSelectionNote">Note: </span>Clicking on Radio Button will make
        the selection your Default Selection. Only one selection from either
        User Defined or Shared with Me can be set as Default Selection.</div>
    </div>
  </div>
</div>


<!-- <div class="i-popup-container" *ngIf="showWidgetExpand">
  <div class="i-popup-model">
    <div class="i-popup-header">
      <div class="i-popup-header-text">{{infoheaderTitle}}</div>
      <div class="i-popup-close" (click)="closeErrorPopUpClick()" title="Close"></div>
    </div>
    <div class="i-popup-body"> -->
<!-- <div class="i-message-block" [ngStyle]="{
              display:customcss(popUpMessage),'height':heightValue
            }">
        {{popUpMessage}}
      </div> -->
<!-- <app-snapshot-chartsparent [chart]="visualization" [id]="i"></app-snapshot-chartsparent>
    </div>
  </div>
</div> -->


<div class="popup-container-save" *ngIf="isSaveSelectionClick && popUpParameter=='SaveSelection'">
  <div class="popup-model">
    <div class="popup-header-save">
      <div class="popup-header-text">{{ headerTitle }}</div>
      <div class="popup-close" (click)="closeSavePopUp()" title="Close"></div>
    </div>
    <div class="popup-body">
      <div class="message-block" style="font-size:0.85rem">
        {{ StaticText }}
      </div>
      <div class="input-box">
        <input type="text" placeholder="Selection name.." [(ngModel)]="SaveSelection" maxlength="50" autocomplete="off"
          name="SaveSelection" (keydown)="onKeyDown($event)" />
      </div>
    </div>
    <div class="popup-footer-save">
      <div class="popup-btn" (click)="onSaveSelectionOkBtnClick()">
        <div class="btn-icon check-circle-icon"></div>
        <div class="btn-text-save">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="popup-container-new" *ngIf="isShareSelectionClick">
  <div class="popup-model-load popup-model" id="shareSelectionPopup">
    <div class="popup-header-new">
      <div class="popup-header-text ">Share this Selection</div>
      <div class="popup-close-new" (click)="closeShareSelectionPopUp()" title="Close"></div>
    </div>
    <div class="popup-body">
      <div class="custom-group-parent-container">
        <div class="group-list-container mcustom">
          <div class="group-header">Search User</div>
          <div class="share-custom-popup-inner-container">
            <div class="share-custom-popup-user-container">
              <div class="share-input-container">
                <input type="text" (input)="showMatchingEmails($event)" placeholder="Enter Email">

              </div>
              <div class="share-button" (click)="onShareSelectionClick()"
                [ngClass]="{'disabled': !isSelectionChanged()}">
                <div class="btn-icon shareImage"></div>
                <div class="share-btn-text">Share Selection</div>
              </div>
              <div class="email-dropdown" *ngIf="isUserListToShareDropdownOpen">
                <div *ngIf="filteredEmailsToShare.length > 0">
                  <div *ngFor="let email of filteredEmailsToShare" class="email-list-container">
                    <div class="checkbox checkbox-icon" [ngClass]="{'checkbox-icon-active':isSharedAlready(email) }"
                      (click)="toggleSelectedEmail(email)">

                    </div>
                    <!-- <input type="checkbox" [value]="email" [checked]="isSharedAlready(email)" (change)="toggleSelectedEmail(email)">
                    <label for="myCheckbox" class="custom-checkbox" [class.checked-image]="isSharedAlready(email)"></label> -->
                    <div class="email-list-content" title="{{email}}">{{ email }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="summary-container ">
          <div class="group-header header-background">Shared User List</div>
          <div class="share-custom-popup-right-container">
            <div *ngFor="let userEmail of selectedEmailsToShare" class="email-list-content" title="{{userEmail}}">
              {{userEmail}}</div>
          </div>
        </div>
      </div>
      <div class="custom-group-button-container popup-footer-save">


        <div class="popup-btn-new" (click)="closeShareSelectionPopUp()">
          <!-- <div class="btn-icon ShareImage"></div> -->
          <div class="btn-text-save">Close</div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="e-OverLay" *ngIf="showSubsctionPopup && popUpParameter=='Subsection'"></div>
<div class="e-popup-container" *ngIf="showSubsctionPopup && popUpParameter=='Subsection'">
  <div class="e-popup-model">
    <div class="e-popup-header">
      <div class="e-popup-header-text">{{'Sub Section'}}</div>
      <div class="e-popup-close" (click)="onConfirmationPopUpCloseBtnClick()" title="Close"></div>
    </div>
    <div class="e-popup-body">
      <!-- <div class="e-message-block" [ngStyle]="{
              display:customcss(popUpMessage),'height':heightValue
            }">
        {{popUpMessage}}
      </div> -->
      <div>
        <input class="widget-input" [style]="'width:47vh'" title="{{subsectionName}}"
          (input)="onSubSectionNameChange($event,true)" [(ngModel)]="subsectionName" maxlength="45" type="text"
          placeholder="Enter the Sub Section Name">
      </div>
    </div>
    <div class="e-popup-footer" [ngClass]="subsectionName==''?'disabled':''" *ngIf="buttonText!=''">
      <div class="e-popup-btn" (click)="onSubSectionPopUpOkBtnClick()">
        <div class="e-btn-icon e-check-circle-icon"></div>
        <div class="e-btn-text">{{'Submit'}}</div>
      </div>
    </div>
  </div>
</div>

<div class="global-default-alert" *ngIf="showGlobalDefaultPopup">
  <span class="global-default-alert-icon">
    <img src="assets/images/cube.svg" />
  </span>
  <span class="global-default-alert-message">
    You're seeing a demo selection to give you a quick glimpse of the Snapshot view.
  </span>
  <button class="global-default-alert-close" (click)="closeGlobalDefaultPopup()">×</button>
</div>

<div class="global-default-alert" *ngIf="BIPSelectedStatus">
  <span class="global-default-alert-icon">
    <img src="assets/images/cube.svg" />
  </span>
  <span class="global-default-alert-message">
    {{widgetString}} is Not Applicable on Brand Imagery Profile
  </span>
  <button class="global-default-alert-close" (click)="closeGlobalDefaultPopup()">×</button>
</div>

<!-- 
<div class="e-OverLay" *ngIf="showMultiFunnelPopup && popUpParameter=='funnelpopup'"></div>
<div  *ngIf="showMultiFunnelPopup && popUpParameter=='funnelpopup'">
  <div class="grid-container">
    <div class="grid-item" *ngFor="let cell of gridData">
      <h3>{{ cell.header }}</h3>
      <p>{{ cell.text }}</p>
    </div>
  </div>
</div> -->